export default __webpack_public_path__ + "static/media/522.ed8796ea.gif";